/*
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned
 * by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import SLAText from './SLAText';
import SLAContainer from './SLAContainer';

/**
 * Class that renders a page that just shows the SLA text within our SLAContainer component.
 */
class ViewSLA extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <SLAContainer>
        <SLAText />
      </SLAContainer>
    );
  }
}

export default ViewSLA;
